import { useTheme } from '@emotion/react';
import styled from '@emotion/styled';

import { Icon, Text, UnstyledButton } from '@myrealtrip/web-ui';

interface Props {
  currentValue: number;
  onIncrease: (e: React.MouseEvent<HTMLButtonElement>) => void;
  onDecrease: (e: React.MouseEvent<HTMLButtonElement>) => void;
  min?: number;
  max?: number;
}

const TravelerCountStepper = ({ currentValue = 0, onIncrease, onDecrease, min, max }: Props) => {
  const theme = useTheme();

  const decreaseStepDisabled = min ? currentValue <= min : false;
  const increaseStepDisabled = max ? currentValue >= max : false;

  return (
    <Container>
      <StepButton type="button" disabled={decreaseStepDisabled} onClick={onDecrease}>
        <Icon
          name="IcoMinus"
          size={20}
          color={decreaseStepDisabled ? theme.colors.gray.s300 : theme.colors.gray.s800}
        />
      </StepButton>
      <InputWrapper>
        <CountText typography="paragraphNormal16">{currentValue}</CountText>
      </InputWrapper>
      <StepButton type="button" disabled={increaseStepDisabled} onClick={onIncrease}>
        <Icon
          name="IcoPlus"
          size={20}
          color={increaseStepDisabled ? theme.colors.gray.s300 : theme.colors.gray.s800}
        />
      </StepButton>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.white};
  width: 104px;
  height: 48px;
  border: 1px solid ${({ theme }) => theme.colors.gray.s100};
  border-radius: 60px;
  padding: 0px 10px;
  > *:not(:last-of-type) {
    margin-right: 2px;
  }
`;

const InputWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
  width: 100%;
  height: 100%;
`;

const CountText = styled(Text)`
  color: ${({ theme }) => theme.colors.gray.s1000};
`;

const StepButton = styled(UnstyledButton)<{ disabled?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};

  &:hover {
    opacity: ${({ disabled }) => (disabled ? 1 : 0.8)};
  }

  &:active {
    opacity: ${({ disabled }) => (disabled ? 1 : 0.9)};
  }
`;

export default TravelerCountStepper;
